// React and hooks / React y hooks
import React, { memo, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

// Components / Componentes
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Disclaimer from '../components/common/Disclaimer';

/**
 * MainLayout - Main layout component for public pages
 * MainLayout - Componente de layout principal para las páginas públicas
 * 
 * This component maintains the basic structure of public pages with:
 * Este componente mantiene la estructura básica de las páginas públicas con:
 * 
 * - Navbar at the top / Navbar en la parte superior
 * - Main content (through Outlet or children) / Contenido principal (a través de Outlet o children)
 * - Footer at the bottom / Footer en la parte inferior
 * 
 * The same structure that exists in App.jsx is used to maintain
 * compatibility with the current design.
 * Se utiliza la misma estructura que ya existe en App.jsx para mantener
 * la compatibilidad con el diseño actual.
 */
const MainLayout = ({ onCartClick, isCartOpen, handleCartClose, children }) => {
  // Memoize the layout structure to prevent unnecessary re-renders
  // Memorizar la estructura del layout para evitar re-renderizados innecesarios
  const layoutContent = useMemo(() => (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Navbar onCartClick={onCartClick} />
        <main className="flex-grow-1">
          {children ? children : <Outlet />}
        </main>
        <Footer />
      </div>
      <Disclaimer />
    </>
  ), [onCartClick, isCartOpen, handleCartClose, children]);
  
  return layoutContent;
};

// Export memoized component to prevent unnecessary re-renders
// Exportar componente memorizado para evitar renderizados innecesarios
export default memo(MainLayout);
